import http from '@/utils/http'
import {getLocalValue, getApiUrl} from '@/utils/commonUtil'

/**
 * @method CRM 元数据接口（hd_metadata）,用于获取列表或详情页，选项集字段和查找字段数据加载
 * @param clientid 用户ID
 * @param tcode getoptions或getlookups
 * @param entityname 实体名称
 * @param fieldname 字段名称
 * @param keyword 关键字段搜索
 * @param pagecount 页数
 * @param pagenumber 页码
 * @param count 返回指定数量
 */
export function hdMetaData (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_metadata`
  return http.post(url, params)
}
/**
 * @method 列表查询（hd_list）
 * @param clientid 用户ID
 * @param tcode 查询code
 * @param P1-P10 参数P1-P10
 * @param keyword 关键字段搜索
 * @param pagecount 页数
 * @param pagenumber 页码
 * @param count 返回指定数量
 */
export function hdList (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_list`
  return http.post(url, params)
}
/**
 * @method 视图查询（hd_view）
 * @param clientid 用户ID
 * @param tcode 0系统1个人
 * @param id 视图ID
 * @param P1-P10 参数P1-P10
 * @param keyword 关键字段搜索
 * @param pagecount 页数
 * @param pagenumber 页码
 * @param count 返回指定数量
 */
export function hdView (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_view`
  return http.post(url, params)
}
/**
 * @method 创建数据（hd_add）
 * @param clientid 用户ID
 * @param tcode 指定code
 * @param content 请求内容（Json字符串）
 */
export function hdAdd (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_add`
  return http.post(url, params)
}
/**
 * @method 修改数据（hd_update）
 * @param clientid 用户ID
 * @param tcode 指定code
 * @param id 视图ID
 * @param content 请求内容（Json字符串）
 */
export function hdUpdate (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_update`
  return http.post(url, params)
}
/**
 * @method 删除数据（hd_delete）
 * @param clientid 用户ID
 * @param tcode 指定code
 * @param id 视图ID
 */
export function hdDelete (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_delete`
  return http.post(url, params)
}
/**
 * @method 表单详情（hd_form）
 * @param clientid 用户ID
 * @param tcode 指定code
 * @param id 视图ID
 */
export function hdForm (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_form`
  return http.post(url, params)
}
/**
 * @method 子表数量统计（hd_count）
 * @param clientid 用户ID
 * @param tcode 指定code
 * @param id 视图ID
 */
export function hdCount (params) {
  // params = {...params, clientid: getLocalValue('userId')}
  let url = `${getApiUrl()}/api/data/v9.1/hd_count`
  return http.post(url, params)
}
/**
 * @method 微信认证-获取用户信息（hd_auth）
 * @param tcode 指定code
 * @param p1 企业微信code
 */
export function hdAuth (code) {
  let params = {tcode: 'getUserId', p1: code}
  let url = `${getApiUrl()}/api/data/v9.1/hd_auth`
  return http.post(url, params)
}
/**
 * @method 微信认证-获取jssdk签名（hd_auth）
 * @param tcode 接口地址
 * @param p1 url地址
 */
export function getSignature (urlLoc) {
  let params = {tcode: 'getSignature', p1: urlLoc}
  let url = `${getApiUrl()}/api/data/v9.1/hd_auth`
  return http.post(url, params)
}
/**
 * @method 维改-商机-阶段跃迁（new_ActionBPFStage）
 */
export function actionBPFStage (entityid) {
  let params = {
    'entityname': 'opportunity',
    'entityid': entityid,
    'type': '1',
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_ActionBPFStage`
  return http.post(url, params)
}
/**
 * @method 详情右上角工作流操作按钮（new_CallWorkflow）
 */
export function callWorkflow (params) {
  const user = getLocalValue('currentUserInfo')
  params.userid = user.id
  let url = `${getApiUrl()}/api/data/v9.1/new_CallWorkflow`
  return http.post(url, params)
}
/**
 * @method 评级-商机等级评估（new_entitygradeapi）
 */
export function entitygradeApi (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_entitygradeapi`
  return http.post(url, params)
}
/**
 * @method 审批页面-同意、转交、拒绝、保留意见（new_ProgressOperation）
 */
export function progressOperation (params) {
  const user = getLocalValue('currentUserInfo')
  params.userid = user.id
  let url = `${getApiUrl()}/api/data/v9.1/new_ProgressOperation`
  return http.post(url, params)
}
/**
 * @method 获取审批历史（hd_queryhistorynodelist）
 */
export function queryHistorynodeList (params) {
  let timestamp = new Date().getTime()
  let url = `${getApiUrl()}/api/data/v9.1/hd_queryhistorynodelist?v=${timestamp}`
  return http.post(url, params)
}
/**
 * @method 获取EDOC目录（new_ActionEdocCreateFolder）
 */
export function actionEdocCreateFolder (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_ActionEdocCreateFolder`
  return http.post(url, params)
}
/**
 * @method 创建crm附件记录（new_CreateAttachment）
 */
export function createAttachment (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_CreateAttachment`
  return http.post(url, params)
}
/**
 * @method 附件上传-开始（StartUploadEdocFile）
 */
export function startUploadEdocFile (edocurl, params) {
  let url = `${edocurl}/api/services/Transfer/StartUploadFile`
  return http.post(url, JSON.stringify(params))
}
/**
 * @method 附件上传-中间（UploadFileBlock）
 */
export function uploadEdocFile (edocurl, params) {
  let url = `${edocurl}/api/services/Transfer/UploadFileBlock`
  return http.post(url, JSON.stringify(params))
}
/**
 * @method 附件上传-结束（EndUploadEdocFile）
 */
export function endUploadEdocFile (edocurl, params) {
  let url = `${edocurl}/api/services/Transfer/EndUploadFile`
  return http.post(url, JSON.stringify(params))
}
/**
 * @method 提交赢单和丢单（new_ActionUpdateFieldByOwnerId）
 */
export function actionUpdateFieldByOwnerId (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_ActionUpdateFieldByOwnerId`
  return http.post(url, params)
}
/**
 * @method 根据经纬度获取百度地图地址（new_BaiDuMap）
 */
export function getBaiDuMap (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_BaiDuMap`
  return http.post(url, params)
}
/**
 * @method 创建联系人（new_N2NRelationship）
 */
export function createContact (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_N2NRelationship`
  return http.post(url, params)
}
/**
 * @method 获取合同确认书/已结算服务费（new_GetTBJContractConfirmInfo）
 */
export function getTBJContractConfirmInfo (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_GetTBJContractConfirmInfo`
  return http.post(url, params)
}
/**
 * @method 获取审批历史信息（new_GetTBJContractApprovalList）
 */
export function getTBJContractApprovalList (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_GetTBJContractApprovalList`
  return http.post(url, params)
}
/**
 * @method 获取TBJ版本对比信息以及付款方式对比信息（new_GetTBJVersionCompare）
 */
export function getGetTBJVersionCompare (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_GetTBJVersionCompare`
  return http.post(url, params)
}
/**
 * @method TBJ/增费审批权限校验（new_TBJContractApprovalAction）
 */
export function tbjContractApprovalAction (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_TBJContractApprovalAction`
  return http.post(url, params)
}
/**
 * @method 根据用户名获取工号
 */
export function getStaffnumber (params) {
  let url = `${getApiUrl()}/api/data/v9.1/new_GetStaff_number`
  return http.post(url, params)
}
/**
 * @method 合同进度汇总接口--合同信息与合同审批列表信息
 * @param type 待我办理:300000000 ,我已提交: 2 ,我已办理: 300000001
 * @param cid  合同id
 */
export function getContractDetail (type, cid) {
  var parameters = {}
  parameters.input = `{"workflow":"all","type":"${type}","cid":"${cid}"}`
  let url = `${getApiUrl()}/api/data/v9.2/new_ActionTodoDetailContract`
  return http.post(url, parameters)
}

/**
 * @method 获取八种新增流程待办已办列表
 * @param type 待我办理:300000000 ,我已提交: 2 ,我已办理: 300000001
 * @param cid  合同id
 */
export function getTodoCenterList (params) {
  const user = getLocalValue('currentUserInfo')
  params.userid = user.id
  let url = `${getApiUrl()}/api/data/v9.1/new_GetTodoCenterList`
  return http.post(url, params)
}

/**
 * @method 获取Edoc登录toklen
 */
export function getEdocLoginToken () {
  let url = `${getApiUrl()}/api/data/v8.2/new_EdocTempLoginToken?v=${(new Date()).valueOf()}`
  return http.post(url)

  // var strcookie = document.cookie// 获取cookie字符串
  // var arrcookie = strcookie.split('; ')// 分割
  // let token = ''
  // // 遍历匹配 获取token
  // for(var i = 0; i < arrcookie.length; i++) {
  //   var arr = arrcookie[i].split('=')
  //   if(arr[0] === 'token') {
  //     token = arr[1]
  //     break
  //   }
  // }
  // debugger
  // console.log(token)
  // // 添加请求头
  // let config = {
  //   headers: {
  //     'access-token': token,
  //   },
  // }
  // return http.post(url, null, config)
}

/**
 * @method EDOC免登录
 */
export function getEdocLogin () {
  const user = getLocalValue('currentUserInfo')
  let parameters = {}
  parameters.RequestStr = `{"Useremail":"${user.new_email}","DomainIp":""}`
  parameters.OperateType = '0'
  parameters.FuncNum = 'EDOCUserLogin'
  let url = `${getApiUrl()}/api/data/v9.1/new_InterfaceRequest`
  return http.post(url, parameters)
}

/**
 * @method 获取合同非标准商务条款明细列表
 * @param id 主表id
 */
export function getProvisionsDetailList (id) {
  let parameters = {}
  const user = getLocalValue('currentUserInfo')
  parameters.InputParameter = `{"provisionsId":"${id}","userid":"${user.id}"}`

  let url = `${getApiUrl()}/api/data/v9.1/new_GetProvisionsDetailList`
  return http.post(url, parameters)
}

/**
 * @method 合同非标准商务条款明细批量更新
 * @param entityId 主表id
 * @param provisionsdetailIds 明细id数组
 * @param type 操作类型（同意传"1",拒绝传"3",保留意见传"4",）
 */
export function ProvisionsDetailBatchApproval (entityId, provisionsdetailIds, type) {
  let params = {
    specialprovisionsId: entityId,
    provisionsdetailId: provisionsdetailIds,
    operaType: type,
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_ProvisionsDetailBatchApproval`
  return http.post(url, JSON.stringify(params))
}

/**
 * @method 获取特殊价格审批单据审批历史
 * @param opportunityId 商机id
 */
export function GetSpecialPriceHistoryAction (opportunityId) {
  let params = {
    OpportunityId: opportunityId,
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_GetSpecialPriceHistoryAction`
  return http.post(url, JSON.stringify(params))
}

/**
 * @method 维保报价单字段赋值/审批Action
 * @param opportunityId 商机id
 */
export function ActionOperateQuotation (operation, quotationid, taskid) {
  let params = {
    operation: operation,
    new_quotationid: quotationid,
    taskid: taskid,
  }
  let parameters = {
    InputPara: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_ActionOperateQuotation`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method TBJ字段数据对比Action
 * @param tbjId tbjId
 */
export function GetTBJDataCompareAction (tbjId) {
  let params = {
    EntityId: tbjId,
  }
  let parameters = {
    InputPara: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_TBJDataCompareAction`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method TBJ前后版本数据对比Action
 * @param tbjId tbjId
 */
export function GetTBJVersionCompareAction (tbjId, contractId, ActionType) {
  let params = {
    EntityId: tbjId,
    ContractId: contractId,
    ActionType: ActionType,
  }
  let parameters = {
    InputPara: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_TBJVersionCompare`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 梯种浮率表批量更新
 * @param provisionsdetailIds 梯种浮率表集合
 */
export function BatchLadderFloatRate (id, LadderFloatRateMeterList) {
  let params = {
    new_specialpriceformid: id,
    InPutParaJson: JSON.stringify(LadderFloatRateMeterList),
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_BatchLadderFloatRate`
  return http.post(url, JSON.stringify(params))
}

/**
 * @method 获取常用审批意见
 * @param entityid 用户id
 * @param executioncode 执行编码
 */
export function ActionUsedAdminRights (entityid, executioncode) {
  let params = {
    entityid: entityid,
    executioncode: executioncode,
  }
  let parameters = {
    data: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_ActionUsedAdminRights`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 根据Code获取数据共用Action
 * @param ActionCode 对应方法的code
 * @param params 灵活参数
 */
export function GetDataByCodeAction (ActionCode, params) {
  let parameters = {
    ActionCode: ActionCode,
    InputPara: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_GetDataByCodeAction`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 新旧价格转换Action
 * @param opportunityId 商机id
 */
export function NewOldPriceConvertAction (formData) {
  let params = {
    ladderTypeId: formData.ladderTypeId,
    ladderTypeName: formData.ladderTypeName,
    load: formData.load,
    speed: formData.speed,
    layer: formData.layer,
    openform: formData.openform,
    oldBasicElevatorPriceVersion: formData.oldBasicElevatorPriceVersion,
    newBasicElevatorPriceVersion: formData.newBasicElevatorPriceVersion,
    oldLadderPriceRate: formData.oldLadderPriceRate,
    newLadderPriceRate: formData.newLadderPriceRate,
    userId: getLocalValue('currentUserInfo').id,
  }
  let parameters = {
    InputPara: JSON.stringify(params),
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_NewOldPriceConvertAction`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 字符串加密解密
 * @param typestriong 加密/解密/先加密再解密 1/2/3
 * @param params 灵活参数
 */
export function PageJump (typestriong, decryptstriong, encryptstring) {
  let parameters = {
    typestriong: typestriong,
    decryptstriong: decryptstriong,
    encryptstring: encryptstring,
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_HEDS2CRM_PageJump`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 根据Code获取数据共用Action
 * @param ActionCode 对应方法的code
 * @param params 灵活参数
 */
export function GetMapData (parames) {
  let parameters = {
    Type: parames.Type,
    Longitude: parames.Longitude,
    Latitude: parames.Latitude,
    Distance: parames.Distance,
    ProjectType: parames.ProjectType,
    KeyWord: parames.KeyWord,
  }

  let url = `${getApiUrl()}/api/data/v9.1/new_GetMapData`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 投放问卷方法
 * @param visitid 拜访计划id
 */
export function PutQuestionnaire (visitid) {
  let parameters = {
    new_visitid: visitid,
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_PutQuestionnaire`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * 获取装饰价格分拆明细数据
 * @param {*} tbjid tbjid
 * @returns  dataList
 */
export function QueryContractDecoratePrice (tbjid) {
  let parameters = {
    entityId: tbjid,
    EntityName: 'new_tbj',
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_ActionQueryContractDecoratePrice`
  return http.post(url, JSON.stringify(parameters))
}

/**
 * @method 投放问卷方法
 * @param visitid 拜访计划id
 */
export function GetQrCode (visitid, businessType) {
  let parameters = {
    new_visitid: visitid,
    businessType: businessType,
  }
  let url = `${getApiUrl()}/api/data/v9.1/new_GetQrCode`
  return http.post(url, JSON.stringify(parameters))
}



// WEBPACK FOOTER //
// ./src/api/appForm.js